export default [
  // { text: 'Pending', value: null },
  { text: 'Paused', icon: 'fa-pause', value: 'PAUSED', color: '#ffffff', backgroundColor: '#8a9aa8' },
  { text: 'Strategy', icon: 'fa-chess-king', value: 'STRATEGY', color: '#ffffff', backgroundColor: '#6f9bd6' },
  { text: 'In Progress', icon: 'fa-hourglass-half', value: 'CREATION', color: '#ffffff', backgroundColor: '#1d6fb5' },
  { text: 'Under Review', icon: 'fa-magnifying-glass-plus', value: 'REVIEW', color: '#ffffff', backgroundColor: '#57c4a7' },
  { text: 'Final Review', icon: 'fa-clipboard-check', value: 'FINAL_REVIEW', color: '#ffffff', backgroundColor: '#106b5f' },
  { text: 'Completed', icon: 'fa-circle-check', value: 'DONE', color: '#ffffff', backgroundColor: '#0d5f3f' }
]
